import React from 'react'
import CustomTable from '../../../../components/BasicUI/CustomTable'

const ResultsList = () => {
    return (
        <CustomTable
            containerProps={{ mt: 5 }}
            head={["Title", "Cohort", "Chapter", "Actions"]}
            data={[]}
        />
    )
}

export default ResultsList